import React from 'react';
import { entryPlans, subscriptionPlans } from '../../data/pricingPlans';
import type { CheckoutPlanId } from '../../data/pricingPlans';
import { PricingCard } from './PricingCard';
interface PricingPlansProps {
  onCheckout: (plan: CheckoutPlanId) => void;
  pendingPlan?: CheckoutPlanId | null;
  /** Where the free plan CTA sends the visitor. */
  freeHref?: string;
}
/**
 * The complete five-tier pricing system, grouped by what the buyer is
 * actually deciding: try it once vs. unlimited access. Monthly carries the
 * dominant treatment inside the unlimited row.
 */
export function PricingPlans({
  onCheckout,
  pendingPlan = null,
  freeHref = '/signup'
}: PricingPlansProps) {
  return <div className="space-y-12" data-id="element-1453" data-mp="jov3c6m4hbwv">
      <section aria-labelledby="pricing-entry-heading" data-id="element-1454" data-mp="jp3iy69mqvbr">
        <div className="mb-5 flex items-baseline justify-between gap-4" data-id="element-1455" data-mp="1q4nu3kwx7nso">
          <h3 id="pricing-entry-heading" className="font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-gray-500" data-id="element-1456" data-mp="1q6qjq3u5vewv">
            Start here — pay per scan
          </h3>
          <p className="hidden font-mono text-[11px] uppercase tracking-[0.12em] text-gray-600 sm:block" data-id="element-1457" data-mp="dw54g7aqxfsi">
            No subscription
          </p>
        </div>
        <div className="grid items-stretch gap-5 lg:grid-cols-2" data-id="element-1458" data-mp="9sqeant3fj1c">
          {entryPlans.map(plan => <PricingCard key={plan.id} plan={plan} layout="row" href={plan.id === 'free' ? freeHref : undefined} onCheckout={onCheckout} isLoading={pendingPlan === plan.id} disabled={pendingPlan !== null} data-id="element-1459" data-mp="4v6y3icu4w6r" />)}
        </div>
      </section>

      <section aria-labelledby="pricing-unlimited-heading" data-id="element-1460" data-mp="3ib63x6pyri2q">
        <div className="mb-5 flex items-baseline justify-between gap-4" data-id="element-1461" data-mp="3i8jxxbiq1amm">
          <h3 id="pricing-unlimited-heading" className="font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-gray-500" data-id="element-1462" data-mp="3daibcgm36t6e">
            Unlimited access
          </h3>
          <p className="hidden font-mono text-[11px] uppercase tracking-[0.12em] text-gray-600 sm:block" data-id="element-1463" data-mp="2yqo1qltmat0t">
            Cancel anytime
          </p>
        </div>
        <div className="grid items-stretch gap-5 md:grid-cols-2 lg:grid-cols-3 lg:pt-3" data-id="element-1464" data-mp="2orgmft3boob2">
          {subscriptionPlans.map(plan => <PricingCard key={plan.id} plan={plan} onCheckout={onCheckout} isLoading={pendingPlan === plan.id} disabled={pendingPlan !== null} data-id="element-1465" data-mp="2trkuqvu2ucq7" />)}
        </div>
      </section>
    </div>;
}